<template>
  <el-result icon="warning" title="人機驗證" subTitle="為了保護您的帳號安全，請完成以下驗證。">
      <template slot="extra">
        <div id="turnstile-container"></div>
      </template>
    </el-result>
</template>

<script>
export default {
  data() {
    return {
      scriptLoaded: false
    };
  },
  created() {
    this.loadTurnstileScript().then(() => {
      this.renderTurnstile();
    });
  },
  methods: {
    loadTurnstileScript() {
      return new Promise((resolve, reject) => {
        if (window.turnstile) {
          return resolve();
        }

        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
        script.async = true;
        script.defer = true;

        script.onload = () => {
          resolve();
        };

        script.onerror = () => {
          reject(new Error('Failed to load Turnstile script'));
        };

        document.head.appendChild(script);
      });
    },

    renderTurnstile() {
      if (!window.turnstile) {
        console.error('Turnstile is not available');
        return;
      }

      window.turnstile.render('#turnstile-container', {
        sitekey: '0x4AAAAAABoFE6m15pj9avtJ',
        callback: (token) => {
          this.$emit('success', token);
        },
        'error-callback': () => {
          this.$emit('error', '验证失败，请重试');
        },
        'expired-callback': () => {
          this.$emit('expired', '验证过期，请重新验证');
        }
      });
    }
  }
};
</script>
